import React from 'react';
import BlogJourney from '../../components/BlogJourney/BlogJourney';

const BlogJourneyPage = () => {
  return <BlogJourney />;
};

export default BlogJourneyPage;
